import { resolveScreen } from './screens';
import { trackScreen } from './tracker';

interface RouterLike {
  state: {
    location: { pathname: string; search: string; key: string };
    historyAction: string;
  };
  subscribe: (listener: (state: RouterLike['state']) => void) => () => void;
}

/**
 * За это время гард успевает увести с экрана через replace (RegionGuard без
 * региона) — такой экран человек не видел, и просмотр ему не засчитываем
 */
const REDIRECT_WINDOW_MS = 300;

/**
 * Один слушатель роутера на всё приложение, вне React: StrictMode и
 * перерисовки его не задевают. Роутер шлёт состояние и на загрузки, и на
 * fetcher'ы — просмотр считаем только по новой записи истории. Повтор того же
 * пути не считается, а возврат назад — новый просмотр
 */
export function trackRouterScreens(router: RouterLike): () => void {
  let lastKey: string | undefined;
  let lastPathname: string | undefined;
  let pending:
    | { timer: ReturnType<typeof setTimeout>; send: () => void }
    | undefined;

  const flush = () => {
    if (!pending) return;
    clearTimeout(pending.timer);
    const { send } = pending;
    pending = undefined;
    send();
  };

  const handle = (state: RouterLike['state']) => {
    const { location, historyAction } = state;
    if (location.key === lastKey) return;
    lastKey = location.key;

    if (historyAction === 'REPLACE' && pending) {
      clearTimeout(pending.timer);
      pending = undefined;
    } else {
      flush();
    }

    const resolved = resolveScreen(location.pathname, location.search);
    if (!resolved) {
      // Ушли на экран без просмотра (вкладка аптек, редирект): возврат
      // на прежний путь — снова просмотр
      lastPathname = undefined;
      return;
    }

    if (location.pathname === lastPathname && historyAction !== 'POP') return;

    const send = () => {
      lastPathname = location.pathname;
      trackScreen(resolved.screen, resolved.path);
    };
    pending = { send, timer: setTimeout(flush, REDIRECT_WINDOW_MS) };
  };

  handle(router.state);
  return router.subscribe(handle);
}
